const startFromFilter = function (input, start) {
    if (!input || start === undefined) {
        return [];
    }
    start = +start; // parse to int
    return input.slice(start);
};

module.exports = startFromFilter;
